module.exports = __webpack_public_path__ + "static/media/Eco Verde Logo.868d7e22.jpg";